// Story 6.9 (ADO-1163, AC4) — Select / Dropdown.
//
// Epic 7 3 amigos (2026-11-02): every form dropdown has the design-system look (Figma
// "Dropdown Field" 532:3457 opening "Dropdown Menu" 5165:8851), never the browser's native
// popup. So this is the design-system `Listbox` with a string value and a placeholder for the
// unchosen state; the Listbox owns the keyboard model and the ARIA (a select-only combobox).

import { Listbox } from '../Listbox/Listbox';

export interface SelectOption {
  value: string;
  label: string;
}

export interface SelectProps {
  label: string;
  options: readonly SelectOption[];
  /** The chosen value; `''` shows the placeholder. */
  value: string;
  /** Called with a newly chosen value. */
  onChange: (value: string) => void;
  /** Shown while the value is empty. */
  placeholder?: string;
  disabled?: boolean;
  id?: string;
  className?: string | undefined;
}

export function Select({ placeholder = 'Select', disabled = false, ...rest }: SelectProps) {
  return <Listbox {...rest} placeholder={placeholder} disabled={disabled} />;
}
